// extracted by mini-css-extract-plugin
export var column = "line-module--column--SayCS";